import {environment} from "@environments/environment";
import {AsiFileService, AsiTable, AsiTableData, AsiTableRequest} from "@asi-ngtools/lib";
import {ExportDto, IMiseAJourExamenWebServiceClient, MiseAJourDto, RechercheMiseAjourDto, PaginationResult} from "@resources/resources";
import {Component, EventEmitter, Input, Output, ViewChild, SimpleChange} from "@angular/core";

@Component({
  selector: 'resultats-misesajour',
  templateUrl: './resultats-misesajour.component.html'
})
export class ResultatsMisesAJourComponent {

  @Input() filtreDto: RechercheMiseAjourDto;

  @ViewChild('ceMisesAJourDataTable') articleTable: AsiTable<MiseAJourDto>;
  asiTableData: AsiTableData<MiseAJourDto> = new AsiTableData<MiseAJourDto>();

  @Output() onResults: EventEmitter<any> = new EventEmitter();

  constructor(private miseAJourService: IMiseAJourExamenWebServiceClient,
              private fileUtils: AsiFileService) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChange) {
    this.articleTable.fireRefresh();
  }

  refreshTable(asiTableRequest: AsiTableRequest) {
    this.filtreDto = {...this.filtreDto, ...asiTableRequest};

    this.searchMiseAJour();
  }

  searchMiseAJour() {
    this.miseAJourService.searchMisesAJour(this.filtreDto).subscribe((results: PaginationResult<MiseAJourDto>) => {
      this.asiTableData = {...results, paginate: true};
      this.articleTable.updateData(this.asiTableData);
      /*let results = this.asiTableData.results;
      let nb = 0;
      if (results) {
        nb = results.length;
      }*/
      this.onResults.emit(results.totalElements);
    });
  }

  export() {
    let exportDto: ExportDto = new ExportDto();
    exportDto.ids = this.asiTableData.results.map(o => o.id);
    this.miseAJourService.exportMisesAJour(exportDto);

    this.fileUtils.getFileAsBlobFromPostRequest(environment.contextPath + "api/miseajourexamen/export/", exportDto).subscribe((fileAsBlob) => {
      /*let url = window.URL.createObjectURL(fileAsBlob);
       window.open(url, '_blank');*/
      this.saveToFile(fileAsBlob, "misesAJour.csv");
    }), error => {
      console.log("error", error);
    };
  }

  private saveToFile(fileAsBlob: Blob, fileName: string) {
    if (window.navigator.msSaveBlob) {
      window.navigator.msSaveBlob(fileAsBlob, fileName);
    } else {
      let url = window.URL.createObjectURL(fileAsBlob);
      var anchor = document.createElement("a");
      anchor.download = fileName;
      anchor.target = '_blank';
      anchor.href = url;
      anchor.dispatchEvent(new MouseEvent("click"));
    }
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/pages/cerba/pages/historique-modifications/resultats/resultats-misesajour.component.ts